'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconStar8Point, iconStar8PointTag } from '@ni/nimble-components/dist/esm/icons/star-8-point';
import { wrap } from '../../utilities/react-wrapper';

export type { IconStar8Point };
export { iconStar8PointTag };
export const NimbleIconStar8Point = wrap(IconStar8Point);